import React from 'react';
import styled from 'styled-components';
import {device} from '../MainContents/Style/StyleDevice'


// Style 宣言
const HeadingMarginColor = styled.div`
  margin-top: 30px;
  padding: 70px 25px 90px;
  background-image: linear-gradient(0deg, #990820 0%, #ba0020 100%) !important;
  color: #fff;
`;

const TableScope = styled.table`
  width: 90%;
  margin:10px auto;
  table-layout: fixed;
  word-wrap: break-word;
  display: table;
  @media ${device.laptop}{
    display: block !important;
  }
`;

const GenderCoColor = styled.span`
  color:blue;
`;
const GenderFemaleColor = styled.span `
  color:red;
`;

const PassingDecision = () => {
  return (
      <>
                  {/* 合不合判定テスト　難関国私立中学　合格判定(可能性 80%)　偏差値 */}
                  {/* 偏差値 */}
                  <HeadingMarginColor className="center" >
                      <h2>四谷大塚　合不合判定テスト　</h2>
                      <h2>県外難関国私立中学　合格判定(可能性 80%)　偏差値目安</h2>
                  </HeadingMarginColor>
  
                  <p>&ensp;&ensp;黒字・・男子校&ensp;&ensp; <GenderFemaleColor>赤字</GenderFemaleColor>・・女子校&ensp;&ensp;  <GenderCoColor>青字</GenderCoColor>・・男女共学校</p>
                  <TableScope className="table table-bordered text-center table-responsive table-scope">
                        <tbody>
                            <tr>
                                <td>偏差値</td>
                                <td>1月上旬</td>
                                <td>1月中旬</td>
                                <td>1月下旬</td>
                                <td>2月1日以降</td>
                            </tr>
                          <tr>
                            <td>73</td>
                            <td></td>
                            <td>灘[3科]</td>
                            <td></td>
                            <td><GenderCoColor>筑波大駒場[4科]</GenderCoColor></td>
                          </tr>
                          <tr>
                            <td>71</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>開成[4科]・<GenderFemaleColor>桜蔭[4科]</GenderFemaleColor></td>
                          </tr>
                          <tr>
                            <td>70</td>
                            <td></td>
                            <td></td>
                            <td><GenderCoColor>澁谷教育幕張[4科]</GenderCoColor></td>
                            <td><GenderFemaleColor>豊島岡女子[4科]</GenderFemaleColor></td>
                          </tr>
                          <tr>
                            <td>69</td>
                            <td></td>
                            <td></td>
                            <td>東大寺学園[3科]</td>
                            <td><GenderFemaleColor>女子学院[4科]</GenderFemaleColor> </td>
                          </tr>
                          <tr>
                            <td>68</td>
                            <td></td>
                            <td></td>
                            <td><GenderFemaleColor>西大和学園女子[3科]</GenderFemaleColor>・<GenderCoColor>洛南高校附[4科]</GenderCoColor></td>
                            <td>麻布[4科]・<GenderFemaleColor>雙葉[4科]</GenderFemaleColor></td>
                          </tr>
                          <tr>
                            <td >67</td>
                            <td></td>
                            <td></td>
                            <td ></td>
                            <td>栄光学園[4科]</td>
                          </tr>
                          <tr>
                            <td >65</td>
                            <td ></td>
                            <td><GenderFemaleColor>神戸女学院[4科]</GenderFemaleColor></td>
                            <td><GenderCoColor>西大和学園[3科]</GenderCoColor></td>
                            <td><GenderFemaleColor>浦和明の星[4科]・フェリス女学院[4科]</GenderFemaleColor></td>
                          </tr>
                          <tr>
                            <td>64</td>
                            <td></td>
                            <td>甲陽学院[3科]</td>
                            <td><GenderCoColor>久留米大附設[4科]</GenderCoColor></td>
                            <td></td>
                          </tr>
                          <tr>
                            <td >63</td>
                            <td ></td>
                            <td></td>
                            <td>ラ・サール[4科]</td>
                            <td>海城[4科]</td>
                          </tr>
                          <tr>
                            <td >61</td>
                            <td></td>
                            <td><GenderFemaleColor>四天王寺英数Ⅱ[3科]</GenderFemaleColor></td>
                            <td></td>
                            <td><GenderFemaleColor>鴎友学園[4科]</GenderFemaleColor></td>
                          </tr>
                          <tr>
                            <td>60</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                          </tr>
                          <tr>
                            <td>59</td>
                            <td></td>
                            <td>六甲学院[3科]</td>
                            <td></td>
                            <td></td>
                          </tr>
                          <tr>
                            <td >58</td>
                            <td><GenderCoColor>愛光松山[4科]</GenderCoColor></td>
                            <td></td>
                            <td><GenderCoColor>広島大附属[4科]</GenderCoColor></td>
                            <td></td>
                          </tr>
                          <tr>
                            <td >56</td>
                            <td></td>
                            <td></td>
                            <td><GenderCoColor>高槻[3科]</GenderCoColor></td>
                            <td></td>
                          </tr>
                          <tr>
                            <td >55</td>
                            <td><GenderCoColor>岡山白陵[3科]</GenderCoColor></td>
                            <td ></td>
                            <td >広島学院[4科]</td>
                            <td ><GenderFemaleColor>ノートルダム清心[4科]</GenderFemaleColor></td>
                          </tr>
                          <tr>
                            <td >54</td>
                            <td><GenderCoColor>青雲[4科]</GenderCoColor></td>
                            <td ></td>
                            <td ></td>
                            <td ></td>
                          </tr>
                          <tr>
                            <td >53</td>
                            <td></td>
                            <td><GenderCoColor>同志社[4科]</GenderCoColor></td>
                            <td></td>
                            <td></td>
                          </tr>
                          <tr>
                            <td >50</td>
                            <td></td>
                            <td ></td>
                            <td ></td>
                            <td><GenderCoColor>土佐[4科]</GenderCoColor></td>
                          </tr>
                        </tbody>
                    </TableScope>
          </>
      );
    };
export default PassingDecision;